<template>
  <div id="app">
    <AppNotifications />
    <AppLoader v-if="getIsAppLoading" />
    <Header />
    <router-view/>
    <Footer />
    <QuickView v-if="!!getQuicKViewProduct" />
  </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import AppNotifications from '@/shared/components/shared/AppNotifications'
import AppLoader from '@/shared/components/shared/AppLoader'
import Header from '@/shared/components/layout/Header'
import Footer from '@/shared/components/layout/Footer'
import QuickView from '@/shared/components/product/ProductQuickView'

export default {
  name: 'App',
  components: {
    AppNotifications,
    AppLoader,
    Header,
    Footer,
    QuickView
  },
  watch: {
    isUserLoggedIn() {
      this.redirectIfFreelancer()
      this.fetchUserCartProducts()
    },
    '$route'() {
      this.redirectIfFreelancer()
    }
  },
  async beforeCreate() {
    if (window.localStorage && window.localStorage.freelancerVuex) {
      const vuexData = JSON.parse(window.localStorage.freelancerVuex)
      if (vuexData && vuexData.auth && vuexData.auth.isUserLoggedIn) {
        this.$store.dispatch('storeFromVuexFreelancer', vuexData.auth)
      }
    }
    this.$store.dispatch('openAuthModal', false)
    this.$store.dispatch('globalLoading', false)
  },
  async created() {
    this.$store.dispatch('validateAuthToken')
    this.redirectIfFreelancer()
    if (this.isTokenExpired) this.signOut()
    await this.fetchCategories()
    this.fetchUserCartProducts()
    this.getUserDetails()
  },
  computed: {
    ...mapGetters ([
      'getIsAppLoading',
      'getGuestCart',
      'getUserCart',
      'isUserLoggedIn',
      'getExpiry',
      'getQuicKViewProduct',
      'getUserAuthInfo'
    ]),
    isTokenExpired() {
      return this.getExpiry && new Date(this.getExpiry) < new Date() ? true : false
    }
  },
  methods: {
    ...mapActions([
      'fetchCategories',
      'fetchBuyerAccount',
      'fetchUserCart',
      'updateUserCartItem',
      'addItemToUserCart',
      'resetGuestCart',
      'resetUserCart',
      'logout'
    ]),
    ...mapMutations([
      'userUpdateCookies'
    ]),
    async getUserDetails() {
      if (this.isUserLoggedIn && this.getUserAuthInfo.role !== 'freelancer' ) {
       
        let buyerAccount = await this.fetchBuyerAccount()
        await this.userUpdateCookies(buyerAccount)

      }
    },
    async fetchUserCartProducts() {
      if (this.isUserLoggedIn && this.getUserAuthInfo.role !== 'freelancer' ) {
        await this.fetchUserCart()
        this.cartsMerging()
      }
    },
    async signOut() {
      await this.logout()
      this.resetUserCart()
      if (this.$route.name !== 'Home') {
        this.$router.push({ name: 'Home' })
      }
    },
    async cartsMerging() {
      if (this.getGuestCart.length === 0) {
        this.redirectIfCheckoutWithNoProduct()
        return
      } 
      const promises = []
      if (this.getUserCart.length) {
        this.getGuestCart.forEach((guestItem) => {
          let existingItem = null
          this.getUserCart.forEach(userItem => {
            if ((guestItem.id === userItem.productId) && (guestItem.inco_terms === userItem.inco_terms)) {
              existingItem = userItem
            }
          })
          if (existingItem) {
            const item = {...existingItem}
            item.quantity = parseInt(item.quantity) + parseInt(guestItem.quantity)
            promises.push(this.updateUserCartItem(item))
          } else {
            const item = {...guestItem}
            promises.push(this.addItemToUserCart(item))
          }
        })
      } else {
        this.getGuestCart.forEach((guestItem) => {
          const item = {...guestItem}
          promises.push(this.addItemToUserCart(item))
        })
      }
      await Promise.all(promises)
      this.resetGuestCart()
      setTimeout(async() => {
        await this.fetchUserCart()
        this.redirectIfCheckoutWithNoProduct()
      }, 500)
    },
    redirectIfCheckoutWithNoProduct() {
      if (this.$route.name === 'Checkout' && !this.getUserCart.length) {
        this.$router.push({name: 'Cart'})
      }
    },
    redirectIfFreelancer() {
      if (this.getUserAuthInfo.role === 'freelancer' && window.location.pathname !== '/buy/contact-us') {
        window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}${process.env.VUE_APP_FREELANCER_HOME_PATH}`
      }
    }
  }
} 
</script>
<style lang="scss" scoped>
  /deep/.vue-notification-group {
    top: 50% !important;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
  }
</style>